import { render } from "./PersonasView.vue?vue&type=template&id=0b878ca2&scoped=true"
import script from "./PersonasView.vue?vue&type=script&lang=js"
export * from "./PersonasView.vue?vue&type=script&lang=js"

import "./PersonasView.vue?vue&type=style&index=0&id=0b878ca2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b878ca2"]])

export default __exports__